'use strict';

import register from './core';
import '../functions/jquery-global.js';
import { getCurrentPageHeaderInfo, getIsMobileDevice, trackLink } from '../functions/common';

document.addEventListener("DOMContentLoaded", function () {

  function adjustWidths() {
    var container = document.querySelector('.edu-sticky-blocks-container');

    if (container) {
      var buttons = container.querySelectorAll('.button');
      var labels = container.querySelectorAll('.button__label');

      if (buttons.length === labels.length) {
        for (var i = 0; i < buttons.length; i++) {
          var button = buttons[i];
          var label = labels[i];

          if (button && label) {
            var buttonStyles = window.getComputedStyle(button);

            var buttonMarginBorder = parseFloat(buttonStyles.marginLeft) + parseFloat(buttonStyles.marginRight) + parseFloat(buttonStyles.border);
            var buttonPadding = parseFloat(buttonStyles.paddingLeft) + parseFloat(buttonStyles.paddingRight);
            var effectiveButtonWidth = button.offsetWidth - buttonMarginBorder - buttonPadding;

            var labelStyles = window.getComputedStyle(label);
            var labelMargin = parseFloat(labelStyles.marginLeft) + parseFloat(labelStyles.marginRight);
            var labelPadding = parseFloat(labelStyles.paddingLeft) + parseFloat(labelStyles.paddingRight);
            var effectiveLabelWidth = label.offsetWidth - labelMargin - labelPadding;

            if (effectiveButtonWidth < effectiveLabelWidth) {
              label.style.maxWidth = effectiveButtonWidth + 'px';
            }
          }
        }
      }
    }
  }

  adjustWidths();

  window.addEventListener('resize', function () {
    adjustWidths();
  });
});

// edu-sticky-blocks contains the first application or all application open for application
register('edu-sticky-blocks', function (element) {
  var applications = $(element).find('.edu-sticky-block'),
    $link = $(element).find('.js-track-click');
  var aOffset = applications.offset().top;
  var applicationsHeight = applications.outerHeight();
  var offset = 25;
  var pageHeader = getCurrentPageHeaderInfo();
  var isMobile = getIsMobileDevice();

  if (!isMobile) {
    function setEduStuck() {
      $('.edu-sticky-blocks').addClass("edu-sticky-blocks-stuck");
      var offsetFromTopScrolling = + pageHeader.pageNavigationHeight + offset;
      $('.edu-sticky-blocks').css('top', offsetFromTopScrolling);
    }
    // switches between position absolut and fixed when scrolling
    $(window).scroll(function () {
      var scrollYpos = $(document).scrollTop();
      if (scrollYpos > aOffset - applicationsHeight) {
        setEduStuck();
      }
      else {
        $('.edu-sticky-blocks').css('top', 0);
        $('.edu-sticky-blocks').removeClass("edu-sticky-blocks-stuck");
      }
    });
    // set position stuck if user isn't top of page after page loaded
    if ($(window).scrollTop() != 0) {
      setEduStuck();
    }
  }
  function $openAllApplication() {
    // open/close all applications inside edu-sticky-blocks
    applications.each(function (index, element) {
      var $el = $(element),
        $content = $el.find('.edu-sticky-block-content');
      $content.slideToggle();
      $el.toggleClass('js-edu-sticky-block-open');

      if (index != 0 && $el.hasClass('js-edu-sticky-block-open')) { //application info should open
        $el.slideDown();
      }
      else if (index != 0) {
        $el.slideUp();
      }
    });
  }
  function toggleLabels($elm, setExpanded) {
    var $currentLabel = $elm.attr('aria-label');
    var $nextLabel = $elm.attr('data-alt-label');
    $elm.attr('aria-expanded', setExpanded ? 'true' : 'false');
    $elm.attr('aria-label', $nextLabel);
    $elm.attr('data-alt-label', $currentLabel);
  }
  applications.each(function (index, element) {
    let $el = $(element),
      $flap = $el.find('.edu-button')
    $el.show();
    $flap.hide();
    $flap.on('click', function (e) {
      e.stopPropagation();
      $flap.toggleClass('close');
      $openAllApplication();

      toggleLabels($flap, $flap.hasClass('close'));
    });
    // the first application should be open 
    if (index === 0) {
      $el.addClass('edu-sticky-block-first')
      $flap.click();
      $flap.show();
    }
  });
  $link.on('click', function (e) {
    var label = $(this).attr('title');
    trackLink('ga', 'Click', 'Application Link', label);
    trackLink('sz', 'Click', 'Application Link', label);
  });
});

// edu-more-sticky-blocks conatins the rest of the application, eg if they are not open to the application or elsewhere
register('edu-more-sticky-blocks', function (element) {
  var applications = $(element).find(".edu-sticky-block");
  var $openAllApplication = $(element).find('#moreApplication');
  var $flap = $(element).find(".cross-icon");
  $(element).find('.edu-button').remove();
  $openAllApplication.on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $openAllApplication.slideToggle();
    $flap.toggleClass('close');

    toggleLabels($flap, $flap.hasClass('close'));

    // open/close all applications inside edu-more-sticky-blocks'
    applications.each(function (index, element) {
      var $el = $(element),
        $content = $el.find('.edu-sticky-block-content');
      $el.fadeToggle();
      $content.slideToggle();
      $el.toggleClass('js-edu-sticky-block-open');
    });
  });

  $flap.on('click', function (e) {
    $openAllApplication.click();
  });
  //close all applications by default
  applications.each(function (index, element) {
    let $el = $(element);
    $el.find('.edu-button').remove();
    $el.hide();
    if (index === 0) {
      $el.addClass('edu-sticky-block-first') 
    }
  });

  function toggleLabels($elm, setExpanded) {
    var $currentLabel = $elm.attr('aria-label');
    var $nextLabel = $elm.attr('data-alt-label');
    $elm.attr('aria-expanded', setExpanded ? 'true' : 'false');
    $elm.attr('aria-label', $nextLabel);
    $elm.attr('data-alt-label', $currentLabel);
  }
});


register('edu-more-static-blocks', function (element) {
  var applications = $(element).find(".edu-static-block");
  var $openAllApplication = $(element).find('#moreApplication');
  var international = element.nextElementSibling != null && element.nextElementSibling.classList.contains("edu-international");
  var $flap = $(element).find(".cross-icon");
  $(element).find('.edu-button').remove();

  $openAllApplication.on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $openAllApplication.slideToggle();
    $flap.toggleClass('close');

    toggleLabels($flap, $flap.hasClass('close'));

    // open/close all applications inside edu-more-sticky-blocks'
    applications.each(function (index, element) {
      var $el = $(element),
        $content = $el.find('.edu-static-block-content');
      $el.fadeToggle();
      //$content.slideToggle();
      $el.toggleClass('js-edu-static-block-open');
    });
  });

  $flap.on('click', function (e) {
    $openAllApplication.click();
  });

  //close all applications by default, except for internation student
  applications.each(function (index, element) {
      let $el = $(element);
      $el.find('.edu-button').remove();
      $el.hide();
      if (index === 0) {
        $el.addClass('edu-static-block-first')
      }
  });

  if (!international) {
    $flap.trigger('click');
  }

  //if (international && international.className == "edu-international") {
  //  $openAllApplication.click();
  //}

  function toggleLabels($elm, setExpanded) {
    var $currentLabel = $elm.attr('aria-label');
    var $nextLabel = $elm.attr('data-alt-label');
    $elm.attr('aria-expanded', setExpanded ? 'true' : 'false');
    $elm.attr('aria-label', $nextLabel);
    $elm.attr('data-alt-label', $currentLabel);
  }
});
